import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=86293004&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
import style0 from "./Patients.vue?vue&type=style&index=0&id=86293004&prod&lang=css"
import style1 from "./Patients.vue?vue&type=style&index=1&id=86293004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86293004",
  null
  
)

export default component.exports